import { createFileRoute } from '@tanstack/react-router';

import { HackathonDetailView } from '@/features/Hackathons/HackathonDetailView';

export const Route = createFileRoute('/trainer/batches/$batchId/hackathons/$hackathonId')({
  component: HackathonDetailTab,
});

export function HackathonDetailTab() {
  const { batchId, hackathonId } = Route.useParams();
  return <HackathonDetailView batchId={batchId} hackathonId={hackathonId} />;
}
